import React from 'react';
import { InputContainer } from '../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';


export const VentureUserProfileInfoComponent = ({ onInnerFormChange, selectedVenture }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="FirstName"
              name="FirstName"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.FirstName',
                  selectedVenture?.UserProfile
                )
              }}
              type="text"
              value={selectedVenture?.UserProfile?.FirstName}
          />
       <InputContainer
              label="Last Name"
              name="LastName"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.LastName',
                  selectedVenture?.UserProfile
                )
              }}
              type="text"
              value={selectedVenture?.UserProfile?.LastName}
          />
      <InputContainer
              label="PersonTitle"
              name="PersonTitle"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.PersonTitle',
                  selectedVenture?.UserProfile
                )
              }}
              type="text"
              value={selectedVenture?.UserProfile?.Email}
          />
    <InputContainer
              label="ProfilePicture Url"
              name="ProfilePictureUrl"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.ProfilePictureUrl',
                  selectedVenture?.UserProfile
                )
              }}
              type="text"
              value={selectedVenture?.UserProfile?.ProfilePictureUrl}
          />
    </div>
 }
 expandedPanel="basicInfo"
 headerTitle="Basic Info"
/>
</>
)
export default VentureUserProfileInfoComponent;
